Object.defineProperty(exports,"__esModule",{value:true});var _maxBy2=require("lodash/maxBy");var _maxBy3=_interopRequireDefault(_maxBy2);var _sumBy2=require("lodash/sumBy");var _sumBy3=_interopRequireDefault(_sumBy2);var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _isEmpty2=require("lodash/isEmpty");var _isEmpty3=_interopRequireDefault(_isEmpty2);var _merge2=require("lodash/merge");var _merge3=_interopRequireDefault(_merge2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _index=require("../victory-util/index");

var _victoryLabel=require("../victory-label/victory-label");var _victoryLabel2=_interopRequireDefault(_victoryLabel);
var _victoryContainer=require("../victory-container/victory-container");var _victoryContainer2=_interopRequireDefault(_victoryContainer);
var _victoryTheme=require("../victory-theme/victory-theme");var _victoryTheme2=_interopRequireDefault(_victoryTheme);
var _point=require("../victory-primitives/point");var _point2=_interopRequireDefault(_point);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var defaultLegendData=[
{name:"Series 1"},
{name:"Series 2"}];var


VictoryLegend=function(_React$Component){_inherits(VictoryLegend,_React$Component);function VictoryLegend(){_classCallCheck(this,VictoryLegend);return _possibleConstructorReturn(this,(VictoryLegend.__proto__||Object.getPrototypeOf(VictoryLegend)).apply(this,arguments));}_createClass(VictoryLegend,[{key:"calculateLegendHeight",value:function calculateLegendHeight(





































































textSizes,padding,isHorizontal){var _props=
this.props,data=_props.data,gutter=_props.gutter;
var contentHeight=isHorizontal?
(0,_maxBy3.default)(textSizes,"height").height:
(0,_sumBy3.default)(textSizes,"height")+gutter*(data.length-1);

return padding.top+contentHeight+padding.bottom;
}},{key:"calculateLegendWidth",value:function calculateLegendWidth(

textSizes,padding,isHorizontal){var _props2=
this.props,data=_props2.data,gutter=_props2.gutter,symbolSpacer=_props2.symbolSpacer;
var contentWidth=isHorizontal?
(0,_sumBy3.default)(textSizes,"width")+(gutter+symbolSpacer*3)*(data.length-1):
(0,_maxBy3.default)(textSizes,"width").width+symbolSpacer*2;

return padding.left+contentWidth+padding.right;
}},{key:"getColorScale",value:function getColorScale(

theme){var
colorScale=this.props.colorScale;
var colorScaleOptions=colorScale||theme.colorScale;

if(typeof colorScaleOptions==="string"){
colorScaleOptions=_index.Style.getColorScale(colorScaleOptions);
}

return!(0,_isEmpty3.default)(theme)?colorScaleOptions||theme.colorScale:colorScaleOptions||[];
}},{key:"getCalculatedProps",value:function getCalculatedProps()

{var _this2=this;var
role=this.constructor.role;var _props3=
this.props,data=_props3.data,orientation=_props3.orientation,theme=_props3.theme;var _props4=
this.props,height=_props4.height,padding=_props4.padding,width=_props4.width;

var legendTheme=theme&&theme[role]?theme[role]:{};
var parentStyles=this.getStyles({},legendTheme,"parent");
var colorScale=this.getColorScale(legendTheme);
var isHorizontal=orientation==="horizontal";
var symbolStyles=[];
var labelStyles=[];
var leftOffset=0;

padding=_index.Helpers.getPadding({padding:padding||theme.padding});
height=_index.Helpers.evaluateProp(height||theme.height,data);
width=_index.Helpers.evaluateProp(width||theme.width,data);

var textSizes=data.map(function(datum,i){
var labelStyle=_this2.getStyles(datum,legendTheme,"labels");
symbolStyles[i]=_this2.getStyles(datum,legendTheme,"symbol",colorScale[i]);
labelStyles[i]=labelStyle;

var textSize=_index.TextSize.approximateTextSize(datum.name,labelStyle);
textSize.leftOffset=leftOffset;
leftOffset+=textSize.width;

return textSize;
});

if(!height){
height=this.calculateLegendHeight(textSizes,padding,isHorizontal);
}
if(!width){
width=this.calculateLegendWidth(textSizes,padding,isHorizontal);
}

return _extends({},
this.props,
{isHorizontal:isHorizontal,height:height,labelStyles:labelStyles,padding:padding,parentStyles:parentStyles,symbolStyles:symbolStyles,textSizes:textSizes,width:width});

}},{key:"getStyles",value:function getStyles(

datum,theme,key,color){var
style=this.props.style;
var styleKey=key==="symbol"?"data":key;
var colorScaleStyle=color?{fill:color}:{};
var styles=(0,_merge3.default)({},theme.style[styleKey],colorScaleStyle,style[styleKey],datum[key]);
return _index.Helpers.evaluateStyle(styles,datum);
}},{key:"getSymbolSize",value:function getSymbolSize(

datum,fontSize){
return datum.symbol&&datum.symbol.size?datum.symbol.size:fontSize/2.5;
}},{key:"getSymbolProps",value:function getSymbolProps(

datum,props,i){var

dataComponent=

props.dataComponent,gutter=props.gutter,labelStyles=props.labelStyles,isHorizontal=props.isHorizontal,padding=props.padding,symbolSpacer=props.symbolSpacer,symbolStyles=props.symbolStyles,textSizes=props.textSizes;var
leftOffset=textSizes[i].leftOffset;var
fontSize=labelStyles[i].fontSize;
var symbolShift=fontSize/2;
var style=symbolStyles[i];

var symbolCoords=isHorizontal?{
x:padding.left+leftOffset+symbolShift+(fontSize+symbolSpacer+gutter)*i,
y:padding.top+symbolShift}:
{
x:padding.left+symbolShift,
y:padding.top+symbolShift+(fontSize+gutter)*i};


return(0,_defaults3.default)({},
dataComponent.props,_extends({

key:"symbol-"+i,
style:style,
size:this.getSymbolSize(datum,fontSize),
symbol:style.type},
symbolCoords));


}},{key:"getLabelProps",value:function getLabelProps(

datum,props,i){var

gutter=
props.gutter,isHorizontal=props.isHorizontal,symbolSpacer=props.symbolSpacer,labelComponent=props.labelComponent,labelStyles=props.labelStyles,textSizes=props.textSizes,padding=props.padding;
var style=labelStyles[i];var
fontSize=style.fontSize;
var symbolShift=fontSize/2;

var labelCoords=isHorizontal?{
x:padding.left+textSizes[i].leftOffset+(fontSize+symbolSpacer)*(i+1)+gutter*i,
y:padding.top+symbolShift}:
{
x:padding.left+fontSize+symbolSpacer,
y:padding.top+symbolShift+(fontSize+gutter)*i};


return(0,_defaults3.default)({},
labelComponent.props,_extends({

key:"label-"+i,
style:style,
text:datum.name},
labelCoords));


}},{key:"renderLegendItems",value:function renderLegendItems(

props){var _this3=this;var
data=props.data,dataComponent=props.dataComponent,labelComponent=props.labelComponent;
var legendData=(0,_isEmpty3.default)(data)?defaultLegendData:data;

var dataComponents=legendData.map(function(datum,i){
return _react2.default.cloneElement(
dataComponent,
_this3.getSymbolProps(datum,props,i));

});

var labelComponents=legendData.map(function(datum,i){
return _react2.default.cloneElement(
labelComponent,
_this3.getLabelProps(datum,props,i));

});

return[].concat(_toConsumableArray(dataComponents),_toConsumableArray(labelComponents));
}},{key:"renderGroup",value:function renderGroup(

props,children){var
groupComponent=props.groupComponent,height=props.height,standalone=props.standalone,width=props.width,x=props.x,y=props.y;
var style=props.style||{};
var groupProps={role:"presentation"};
var transform="translate("+x+", "+y+")";
if(!standalone){
groupProps=_extends(groupProps,{height:height,width:width,transform:transform,style:style.parent});
}

return _react2.default.cloneElement(groupComponent,groupProps,children);
}},{key:"renderContainer",value:function renderContainer(

props,children){var
containerComponent=props.containerComponent,height=props.height,width=props.width;
var style=props.style||{};
return _react2.default.cloneElement(
containerComponent,
{height:height,width:width,style:style.parent},
children);

}},{key:"render",value:function render()

{
var props=this.getCalculatedProps();
var group=this.renderGroup(props,this.renderLegendItems(props));
return props.standalone?this.renderContainer(props,group):group;
}}]);return VictoryLegend;}(_react2.default.Component);VictoryLegend.displayName="VictoryLegend";VictoryLegend.role="legend";VictoryLegend.propTypes={colorScale:_react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string),_react.PropTypes.oneOf(["grayscale","qualitative","heatmap","warm","cool","red","green","blue"])]),containerComponent:_react.PropTypes.element,data:_react.PropTypes.arrayOf(_react.PropTypes.shape({name:_react.PropTypes.string.isRequired,label:_react.PropTypes.object,symbol:_react.PropTypes.object})),dataComponent:_react.PropTypes.element,groupComponent:_react.PropTypes.element,gutter:_react.PropTypes.number,height:_react.PropTypes.oneOfType([_index.PropTypes.nonNegative,_react.PropTypes.func]),labelComponent:_react.PropTypes.element,orientation:_react.PropTypes.oneOf(["horizontal","vertical"]),padding:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.shape({top:_react.PropTypes.number,bottom:_react.PropTypes.number,left:_react.PropTypes.number,right:_react.PropTypes.number})]),standalone:_react.PropTypes.bool,style:_react.PropTypes.shape({data:_react.PropTypes.object,labels:_react.PropTypes.object,parent:_react.PropTypes.object}),symbolSpacer:_react.PropTypes.number,theme:_react.PropTypes.object,width:_react.PropTypes.oneOfType([_index.PropTypes.nonNegative,_react.PropTypes.func]),x:_react.PropTypes.number,y:_react.PropTypes.number};VictoryLegend.defaultProps={data:defaultLegendData,containerComponent:_react2.default.createElement(_victoryContainer2.default,null),dataComponent:_react2.default.createElement(_point2.default,null),groupComponent:_react2.default.createElement("g",null),gutter:10,labelComponent:_react2.default.createElement(_victoryLabel2.default,null),orientation:"vertical",standalone:true,style:{},symbolSpacer:8,theme:_victoryTheme2.default.grayscale,x:0,y:0};exports.default=VictoryLegend;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-legend/victory-legend.js
// module id = 1467
// module chunks = 0